import NumberFormatFactory from '@tencent/tdocs-format-render/lib/model/NumberFormatFactory';
import { fmtIsDate, formatValue } from '@tencent/tdocs-format-render';

/**
 * 返回格式化后的数值
 * @param value 要格式化的数值
 */
// eslint-disable-next-line complexity
export const getFormattedNumber = (value, formatPattern?: string) => {
    if (value === null || value === undefined) return '';
    // 目前发现'[=0]g;General'，会被fmtIsDate判定为日期，所以这里提前处理
    if (formatPattern?.includes('General')) return value;
    if (formatPattern === 'm/d/yy') {
        formatPattern = 'yyyy/m/d';
    }
    const numberFormat = NumberFormatFactory.createInstance({ pattern: formatPattern });
    const isDate = fmtIsDate(formatPattern || '');
    if (formatPattern && isDate && value > 60) {
        // 格式为日期时，office中value为60为1900.2.29，实际并没有
        value -= 1;
    }

    // formatCode能自定义，可能是非法值。这里直接try catch一下，如果非法报错就返回原值（office里返回了formatCode的兼容展示，这里不太一样，场景很少，先这么处理）
    try {
        const formattedValue = formatValue(value, numberFormat, {});

        // 没有传格式化字符串的话，就是数值，直接number
        // @ts-ignore
        if (!formatPattern && !isNaN(formattedValue.value)) {
            return Number(formattedValue.value);
        }

        if (isDate) {
            // 截取时间为0:00
            return formattedValue.value?.replace?.(/ 0:00$/, '');
        }

        return formattedValue.value;
    } catch (err) {
        console.error('getFormattedNumber err', err);
        return value;
    }
};

export const CATEGORY_MARK = '__cIndex:';
export const replaceCategoryMark = (value: string) => value.replace(new RegExp(`${CATEGORY_MARK}(\\d+)$`), '');
